import { render } from "./ColourDetailsPanel.vue?vue&type=template&id=28cc6046"
import script from "./ColourDetailsPanel.vue?vue&type=script&lang=js"
export * from "./ColourDetailsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__